<template>
  <div class="assinaturas-isp">
    <h1 class="titulo-card fs-4">Assinaturas</h1>
    <div class="form-group card-principal">
      <div class="d-flex justify-content-between">
        <div class="input-group mb-3">
          <button v-on:click="handleAdicionar()" class="btn btn-success">
            <font-awesome-icon :icon="['fas', 'plus']" fixed-width class="me-1"/>Nova assinatura
          </button>
        </div>

        <div class="input-group mb-3">
          <input
              v-on:keyup.enter="handlePesquisa()"
              type="text"
              class="form-control"
              placeholder="Pesquisar"
              aria-label="Pesquisar"
              aria-describedby="button-addon2">
          <button v-on:click="handlePesquisa()" class="btn btn-outline-secondary" type="button" id="button-addon2">
            <font-awesome-icon :icon="['fas', 'search']" fixed-width class="me-1"/>
          </button>
        </div>
      </div>
      <div class="d-flex">
        <table class="table table-sm-pc table-striped table-hover">
          <thead>
            <tr>
              <th width="25">#</th>
              <th>Cliente</th>
              <th>Endereço</th>
              <th>Plano</th>
              <th width="140"></th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="assinatura in listaAssiaturas" :key="assinatura.id">
                <td scope="row">{{assinatura.id}}</td>
                <td>{{nomeCliente(assinatura.cliente_id)}}</td>
                <td>{{enderecoAssinatura(assinatura.endereco_id)}}</td>
                <td>{{nomePlano(assinatura.plano_id)}}</td>
                <td class="text-end">
                  <router-link v-bind:to="`/assinaturas-isp/${assinatura.id}/mensalidades`" class="btn btn-outline-primary btn-sm me-1">
                    <font-awesome-icon :icon="['fas', 'calendar-alt']" fixed-width/>
                  </router-link>
                  <button type="button" v-on:click="handleEditaAssinaturaISP(assinatura)" class="btn btn-primary btn-sm me-1">
                    <font-awesome-icon :icon="['fas', 'edit']" fixed-width/>
                  </button>
                  <button type="button" v-on:click="handleRemoveAssinaturaISP(assinatura)" class="btn btn-danger btn-sm">
                    <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
                  </button>
                </td>
              </tr>
            </tbody>
        </table>
      </div>
      <Paginador v-model="paginador" @change-paginacao="onChangePaginacao"/>
    </div>

    <!-- modal-edita-assinatura-isp -->
    <!-- Button trigger modal -->
    <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-edita-assinatura-isp" id="btn-modal-edita-assinatura-isp-abre">
      Launch
    </button>

    <!-- Modal -->
    <div class="modal fade" id="modal-edita-assinatura-isp" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="!modalAssinaturaISP.data.id" class="modal-title">
              <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
              Inserir nova assinatura
            </h5>
            <h5 v-if="!!modalAssinaturaISP.data.id" class="modal-title">
              <font-awesome-icon :icon="['fas', 'pen']" fixed-width/>
              Editando assinatura
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12 mb-2">
                <label>Cliente</label>
                <div class="input-group">
                  <input type="text" disabled v-bind:value="textoClienteSelecionado" class="form-control" placeholder="Selecione o cliente" aria-describedby="button-addon2">
                  <button v-on:click="abreModalPesquisaClientes()" class="btn btn-outline-primary" type="button" id="button-addon2">
                    <font-awesome-icon :icon="['fas', 'search']" fixed-width/>
                  </button>
                </div>
              </div>
              <div class="col-12 mb-2" v-if="modalAssinaturaISP.clienteSelecionado">
                <label>Endereco</label>
                <select v-model.number="modalAssinaturaISP.data.endereco_id" class="form-select">
                  <option v-bind:value="0" disabled>Selecione</option>
                  <option v-for="endereco in modalAssinaturaISP.listaEnderecos" :key="endereco.id" v-bind:value="endereco.id">{{formataEndereco(endereco)}}</option>
                </select>
              </div>
            </div>

            <div class="row" v-if="(!!modalAssinaturaISP.data.endereco_id)">
              <div class="col-12 col-sm-6 col-md-3 mb-2">
                <label>Status</label>
                <select v-model="modalAssinaturaISP.data.ativo" class="form-select">
                  <option value="true">Ativo</option>
                  <option value="false">Suspenso</option>
                </select>
              </div>

              <div class="col-12 col-sm-6 col-md-3 mb-2">
                <label>Usuário</label>
                <input v-model="modalAssinaturaISP.data.usuario" type="text" class="form-control">
              </div>

              <div class="col-12 col-sm-6 col-md-3 mb-2">
                <label>Senha</label>
                <input v-model="modalAssinaturaISP.data.senha" type="text" class="form-control">
              </div>

              <div class="col-12 col-sm-6 col-md-3 mb-2">
                <label>Endereço IPv4</label>
                <input v-model="modalAssinaturaISP.data.ipv4_address" type="text" class="form-control">
              </div>

              <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                <label>Plano</label>
                <select v-model.number="modalAssinaturaISP.data.plano_id" class="form-select">
                  <option v-bind:value="0" disabled>Selecione</option>
                  <option v-for="plano in listaPlanos" :key="plano.id" v-bind:value="plano.id">{{plano.descricao}}</option>
                </select>
              </div>

              <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                <label>Data contratado</label>
                <input v-model="modalAssinaturaISP.data.data_contratado" type="date" class="form-control">
              </div>

              <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                <label>Cobrança</label>
                <select v-model="modalAssinaturaISP.data.isento" class="form-select">
                  <option v-bind:value="false">Normal (não isento)</option>
                  <option v-bind:value="true">Isento</option>
                </select>
              </div>

              <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                <label>Vencimento</label>
                <select v-model.number="modalAssinaturaISP.data.dia_vencimento" class="form-select">
                  <option disabled="true" v-bind:value="0">Selecione</option>
                  <option v-bind:value="1">1</option>
                  <option v-bind:value="2">2</option>
                  <option v-bind:value="3">3</option>
                  <option v-bind:value="4">4</option>
                  <option v-bind:value="5">5</option>
                  <option v-bind:value="6">6</option>
                  <option v-bind:value="7">7</option>
                  <option v-bind:value="8">8</option>
                  <option v-bind:value="9">9</option>
                  <option v-bind:value="10">10</option>
                  <option v-bind:value="11">11</option>
                  <option v-bind:value="12">12</option>
                  <option v-bind:value="13">13</option>
                  <option v-bind:value="14">14</option>
                  <option v-bind:value="15">15</option>
                  <option v-bind:value="16">16</option>
                  <option v-bind:value="17">17</option>
                  <option v-bind:value="18">18</option>
                  <option v-bind:value="19">19</option>
                  <option v-bind:value="20">20</option>
                  <option v-bind:value="21">21</option>
                  <option v-bind:value="22">22</option>
                  <option v-bind:value="23">23</option>
                  <option v-bind:value="24">24</option>
                  <option v-bind:value="25">25</option>
                  <option v-bind:value="26">26</option>
                  <option v-bind:value="27">27</option>
                  <option v-bind:value="28">28</option>
                </select>
              </div>

              <div class="col-12 col-sm-12 col-md-4 mb-2">
                <label>Cobrança automática</label>
                <div class="form-check form-switch">
                  <input v-model="modalAssinaturaISP.data.cobranca_automatica" class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                  <label class="form-check-label" for="flexSwitchCheckDefault">Habilitar</label>
                </div>
              </div>

              <div class="col-12 col-sm-6 col-md-4 mb-2">
                <label>Quantas cobranças por vez</label>
                <input v-model.number="modalAssinaturaISP.data.cobranca_automatica_por_vez"
                    v-bind:disabled="(!modalAssinaturaISP.data.cobranca_automatica)"
                    type="number"
                    value="1"
                    min="1"
                    max="12"
                    class="form-control">
              </div>

              <div class="col-12 col-sm-6 col-md-4 mb-2">
                <label>Quantos dias antes de vencer</label>
                <input v-model="modalAssinaturaISP.data.cobranca_automatica_dias_antes_de_vencer"
                    v-bind:disabled="(!modalAssinaturaISP.data.cobranca_automatica)"
                    type="number"
                    value="30"
                    min="1"
                    max="365"
                    class="form-control">
              </div>

              <div class="col-12">
                <label>Observação</label>
                <textarea v-model="modalAssinaturaISP.data.observacao" class="form-control"></textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" id="btn-modal-edita-assinatura-isp-fecha">Fechar</button>
            <button type="button"
                v-if="!modalAssinaturaISP.data.id"
                v-on:click="handleModalAssinaturaISPCadastrar()"
                v-bind:disabled="!podeSalvarAssinaturaISP()"
                class="btn btn-success">
              Cadastrar
            </button>
            <button type="button"
                v-if="!!modalAssinaturaISP.data.id"
                v-on:click="handleModalAssinaturaISPSalvar()"
                v-bind:disabled="!podeSalvarAssinaturaISP()"
                class="btn btn-success">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal-edita-assinatura-isp -->
  </div>
</template>

<script>
import Paginador from '@/components/Paginador.vue'
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import clone from '@/modules/clone'
import model from '@/model'
import pesquisaCliente from '@/modules/pesquisa-cliente'

export default {
  name: 'AssinaturasISP',

  components: {
    Paginador,
  },

  data() {
    return {
      /** @type {model.paginador} */
      paginador: clone(model.paginador),
      listaPlanos: [],
      listaAssiaturas: [],
      listaClientes: [],
      listaEnderecos: [],
      modalAssinaturaISP: {
        clienteSelecionado: undefined,
        listaEnderecos: [],
        data: {
          id: undefined,
          cliente_id: 0,
          endereco_id: 0,
          plano_id: 0,
          ativo: true,
          usuario: '',
          senha: '',
          data_contratado: '',
          isento: false,
          dia_vencimento: 1,
          cobranca_automatica: false,
          cobranca_automatica_por_vez: 1,
          cobranca_automatica_dias_antes_de_vencer: 30,
          observacao: '',
        },
      }
    }
  },

  methods: {
    //TODO: tornar esta função como global
    /**
     * @param {Number} numero
     * @param {Number} zeros
     * @returns {string} Strins com "zeros" à esquerda do número informado
     **/
    strZero(numero, zeros){
        return Array(zeros-String(numero).length+1).join('0') + numero;
    },

    //TODO: tornar esta função como global
    /**
     * @param {Date} data
     * @returns {string} Data no formato YYYY-MM-DD
     **/
    dateToMySQLDateStr(data) {
      const dia = this.strZero(data.getDate(), 2);
      const mes = this.strZero(data.getMonth()+1, 2);

      return `${data.getFullYear()}-${mes}-${dia}`;
    },

    carregaListaPlanos() {
      api.get(`/plano-isp?paginacao.porPagina=-1`).then(res => {
        this.listaPlanos = res.data.itens;
      }).catch(() => {
        setTimeout(() => {
          this.carregaListaPlanos();
        }, 1000);
      });
    },

    handlePesquisa() {
      loading(true);

      api.get(`/assinaturas-isp?${this.paginador.requestParams}`).then(res => {
        loading(false);
        this.listaAssiaturas = res.data.itens;
        this.listaClientes = res.data.clientes;
        this.listaEnderecos = res.data.enderecos;
        this.paginador.pagina = res.data.paginacao.pagina;
        this.paginador.totalItens = res.data.paginacao.total;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    onChangePaginacao() {
      this.handlePesquisa();
    },

    resetModalAssinaturaISP() {
      const hoje = new Date();

      this.modalAssinaturaISP.clienteSelecionado = undefined;
      this.modalAssinaturaISP.data.id = undefined;
      this.modalAssinaturaISP.data.cliente_id = 0;
      this.modalAssinaturaISP.data.endereco_id = 0;
      this.modalAssinaturaISP.data.plano_id = 0;
      this.modalAssinaturaISP.data.ativo = true;
      this.modalAssinaturaISP.data.usuario = '';
      this.modalAssinaturaISP.data.senha = '';
      this.modalAssinaturaISP.data.data_contratado = this.dateToMySQLDateStr(hoje);
      this.modalAssinaturaISP.data.isento = false;
      this.modalAssinaturaISP.data.dia_vencimento = 1;
      this.modalAssinaturaISP.data.cobranca_automatica = false;
      this.modalAssinaturaISP.data.cobranca_automatica_por_vez = 1;
      this.modalAssinaturaISP.data.cobranca_automatica_dias_antes_de_vencer = 30;
      this.modalAssinaturaISP.data.observacao = '';
    },

    handleAdicionar() {
      this.abreModalCadastroAssinaturaISP();
    },

    async handleEditaAssinaturaISP(assinaturaISP) {
      this.resetModalAssinaturaISP();
      this.modalAssinaturaISP.data = clone(assinaturaISP);
      loading(true);

      await pesquisaCliente(assinaturaISP.cliente_id).then(res => {
        api.get(`/clientes/${res.id}/enderecos`).
          then(enderecos => {
            loading(false);
            this.modalAssinaturaISP.clienteSelecionado = clone(res);
            this.modalAssinaturaISP.listaEnderecos = enderecos.data;

            document.getElementById('btn-modal-edita-assinatura-isp-abre').click();
          }).catch(error => {
            loading(false);
            dialogo.erroHttp(error);
          });
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    handleRemoveAssinaturaISP(assinaturaISP) {
      dialogo.confirmacao(`Confirma remover a assinatura do cliente <b>${assinaturaISP.razao_social}</b>?`).then(() => {
        loading(true);

        api.delete(`/assinaturas-isp/${assinaturaISP.id}`).then(() => {
          loading(false);

          this.handlePesquisa();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },

    abreModalCadastroAssinaturaISP() {
      this.resetModalAssinaturaISP();
      document.getElementById('btn-modal-edita-assinatura-isp-abre').click();
    },

    abreModalPesquisaClientes() {
      pesquisaCliente().then(res => {
        loading(true);

        api.get(`/clientes/${res.id}/enderecos`).
          then(enderecos => {
            loading(false);
            this.modalAssinaturaISP.clienteSelecionado = clone(res);
            this.modalAssinaturaISP.data.cliente_id = res.id;
            this.modalAssinaturaISP.listaEnderecos = enderecos.data;
          }).catch(error => {
            loading(false);
            dialogo.erroHttp(error);
          });
      });
    },

    podeSalvarAssinaturaISP() {
      switch (true) {
        case (!this.modalAssinaturaISP.data.cliente_id):
        case (!this.modalAssinaturaISP.data.endereco_id):
        case (!this.modalAssinaturaISP.data.plano_id):
        case (!this.modalAssinaturaISP.data.data_contratado):
        case (this.modalAssinaturaISP.data.usuario.length < 3):
        case (this.modalAssinaturaISP.data.dia_vencimento < 1):
        case (this.modalAssinaturaISP.data.dia_vencimento > 28):
        case (this.modalAssinaturaISP.data.cobranca_automatica_por_vez < 1):
        case (this.modalAssinaturaISP.data.cobranca_automatica_por_vez > 12):
        case (this.modalAssinaturaISP.data.cobranca_automatica_dias_antes_de_vencer < 1):
        case (this.modalAssinaturaISP.data.cobranca_automatica_dias_antes_de_vencer > 365):
          return false;

        default:
          return true;
      }
    },

    handleModalAssinaturaISPCadastrar() {
      const sendData = clone(this.modalAssinaturaISP.data);

      loading(true);

      api.post('/assinaturas-isp', sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-assinatura-isp-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    handleModalAssinaturaISPSalvar() {
      const sendData = clone(this.modalAssinaturaISP.data);

      loading(true);

      api.put(`/assinaturas-isp/${sendData.id}`, sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-assinatura-isp-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    nomePlano(planoID) {
      const plano = this.listaPlanos.find(x => planoID === x.id);

      if (!plano) {
        return '';
      }

      return plano.descricao;
    },

    nomeCliente(clienteID) {
      const cliente = this.listaClientes.find(x => clienteID === x.id);

      if (!cliente) {
        return '';
      }

      return cliente.razao_social;
    },

    enderecoAssinatura(enderecoID) {
      const endereco = this.listaEnderecos.find(x => enderecoID === x.id);

      if (!endereco) {
        return '';
      }

      return this.formataEndereco(endereco);
    },

    //TODO: fazer esta função ser global
    formataEndereco(endereco) {
      let resultado = '';

      // resultado += `${endereco.id} - `;
      resultado += endereco.logradouro;

      if (endereco.numero) {
        resultado += `, ${endereco.numero}`;
      }

      if (endereco.complemento) {
        resultado += ` ${endereco.complemento}`;
      }

      resultado += ` - ${endereco.bairro}`;
      resultado += ` - ${endereco.cidade}`;
      resultado += ` - ${endereco.uf}`;

      return resultado;
    }
  },

  computed: {
    textoClienteSelecionado() {
      if (!this.modalAssinaturaISP.clienteSelecionado) {
        return '';
      }

      return this.modalAssinaturaISP.clienteSelecionado.razao_social;
    }
  },

  created() {
    this.carregaListaPlanos();
    this.handlePesquisa();
  }
}
</script>
